// extracted by mini-css-extract-plugin
export default {"wrapper":"cr-z","response":"dr-z","error":"er-z","disabled":"fr-z","buttons":"gr-z","feedbackQuestionSection":"hr-z","yesNoWrapper":"ir-z"};